export const icons = {
   mastercard: (
    <svg
      width="38"
      height="23"
      viewBox="0 0 38 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6316 20.049C16.6582 21.7124 14.0984 22.7166 11.3011 22.7166C5.0597 22.7166 0 17.7171 0 11.5499C0 5.38276 5.0597 0.38327 11.3011 0.38327C14.0984 0.38327 16.6582 1.38743 18.6316 3.05084C20.605 1.38743 23.1649 0.38327 25.9621 0.38327C32.2036 0.38327 37.2632 5.38276 37.2632 11.5499C37.2632 17.7171 32.2036 22.7166 25.9621 22.7166C23.1649 22.7166 20.605 21.7124 18.6316 20.049Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6316 20.049C21.0615 18.0009 22.6023 14.9532 22.6023 11.5499C22.6023 8.14668 21.0615 5.09901 18.6316 3.05084C20.605 1.38743 23.1649 0.38327 25.9621 0.38327C32.2035 0.38327 37.2632 5.38276 37.2632 11.5499C37.2632 17.7171 32.2035 22.7166 25.9621 22.7166C23.1649 22.7166 20.605 21.7124 18.6316 20.049Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6316 20.049C21.0615 18.0009 22.6023 14.9532 22.6023 11.55C22.6023 8.14673 21.0615 5.09908 18.6316 3.0509C16.2018 5.09908 14.661 8.14673 14.661 11.55C14.661 14.9532 16.2018 18.0009 18.6316 20.049Z"
        fill="#FF5E00"
      />
    </svg>
  ),
  visa: (
    <svg
      width="40"
      height="14"
      viewBox="0 0 40 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91708 13.4304H6.48418L3.90993 3.32063C3.78774 2.85558 3.52831 2.44444 3.14669 2.25067C2.19431 1.76372 1.14486 1.37618 0 1.18072V0.791494H5.53013C6.29337 0.791494 6.8658 1.37618 6.96121 2.05522L8.29688 9.34775L11.7281 0.791494H15.0656L9.91708 13.4304ZM16.9737 13.4304H13.7316L16.4013 0.791494H19.6434L16.9737 13.4304ZM23.8382 4.29286C23.9336 3.61213 24.506 3.2229 25.1739 3.2229C26.2233 3.12518 27.3665 3.32063 28.3205 3.8059L28.893 1.08468C27.9389 0.695456 26.8895 0.5 25.9371 0.5C22.7904 0.5 20.5007 2.25068 20.5007 4.6804C20.5007 6.52881 22.1226 7.49934 23.2674 8.08403C24.506 8.66703 24.983 9.05625 24.8876 9.63925C24.8876 10.5137 23.9336 10.903 22.9812 10.903C21.8364 10.903 20.6915 10.6115 19.6437 10.1245L19.0713 12.8474C20.2161 13.3327 21.4547 13.5282 22.5996 13.5282C26.1279 13.6242 28.3205 11.8752 28.3205 9.25002C28.3205 5.94412 23.8382 5.75035 23.8382 4.29286V4.29286ZM39.6667 13.4304L37.0924 0.791494H34.3273C33.7549 0.791494 33.1825 1.18072 32.9917 1.76372L28.2248 13.4304H31.5623L32.2284 11.5837H36.3292L36.7108 13.4304H39.6667ZM34.8044 4.19514L35.7567 8.95854H33.0871L34.8044 4.19514Z"
        fill="#172B85"
      />
    </svg>
  ),
  verve: (
    <svg
      width="40"
      height="14"
      viewBox="0 0 40 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8831 6.97472C13.8831 10.7792 10.799 13.8633 6.99455 13.8633C3.18991 13.8633 0.105713 10.7792 0.105713 6.97472C0.105713 3.17025 3.18991 0.0861365 6.99455 0.0861365C10.799 0.0861365 13.8831 3.17025 13.8831 6.97472Z"
        fill="#ED342B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99427 9.92547C5.45344 6.43281 4.32365 3.16999 4.32365 3.16999H1.96155C1.96155 3.16999 3.39924 7.35783 6.06977 12.595H7.91879C10.5893 7.35783 12.0269 3.16999 12.0269 3.16999H9.66481C9.66481 3.16999 8.53512 6.43281 6.99427 9.92547Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6609 6.61542C35.3256 6.61542 35.2231 8.05337 35.2231 8.05337H38.0985C38.0985 8.05337 37.996 6.61542 36.6609 6.61542ZM39.8447 9.49105H35.2231C35.2231 9.49105 35.3256 11.0318 37.3799 11.0318C38.4068 11.0318 39.4339 10.7234 39.4339 10.7234L39.6394 12.3666C39.6394 12.3666 38.6123 12.7777 37.1744 12.7777C35.1204 12.7777 33.2717 11.7505 33.2717 8.87489C33.2717 6.61542 34.7096 5.17756 36.7637 5.17756C39.8447 5.17756 40.0499 8.25864 39.8447 9.49105ZM24.1296 7.06435L24.4476 5.3686C24.4476 5.3686 21.992 4.62349 19.9962 6.00432V12.7873H22.1158V7.27611C22.9636 6.64048 24.1296 7.06435 24.1296 7.06435ZM15.2944 6.61542C13.9593 6.61542 13.8567 8.05337 13.8567 8.05337H16.7322C16.7322 8.05337 16.6297 6.61542 15.2944 6.61542ZM18.4781 9.49105H13.8567C13.8567 9.49105 13.9593 11.0318 16.0133 11.0318C17.0401 11.0318 18.0673 10.7234 18.0673 10.7234L18.2728 12.3666C18.2728 12.3666 17.2457 12.7777 15.8078 12.7777C13.7538 12.7777 11.905 11.7505 11.905 8.87489C11.905 6.61542 13.343 5.17756 15.397 5.17756C18.4781 5.17756 18.6834 8.25864 18.4781 9.49105ZM29.3023 10.1949C28.2261 7.61161 27.6881 5.1788 27.6881 5.1788L25.536 5.17906C25.536 5.17906 26.6122 9.33376 28.4418 12.7764H30.1629C31.9926 9.33376 33.0688 5.17966 33.0688 5.17966H30.9166C30.9166 5.17966 30.3786 7.61161 29.3023 10.1949Z"
        fill="#03435F"
      />
    </svg>
  ),
}